import { styled } from "styled-components";
import Layout from "../components/Layout";
import HeroImage  from "../assets/images/recruit.jpg";
import Arrow from "../assets/images/chevron-right.svg";

function Recruit() {
  return (
    <Layout>
      <RecruitWrapper className="layoutWrapper">
        <Hero />
        <Top>
        <H3>A place where you can grow</H3>
        <Statement>With a strong engineering culture, we’re a diverse, collaborative team. 
In partnership with our business, functional, regional and market teams, more than 17,000 technologists work together, every day across our unique geographic footprint.
Collectively, we bring passion, innovation, diversity of thought and culture, and our ambition to realise our transformation journey and digitise our employee and customer journeys end-to-end. 
</Statement>
        </Top>
        <H3>Ready to apply?</H3>
        <Statement>Whether you’re fresh from university or looking for your next career opportunity, we’d love to hear from you.</Statement>
        <a href="https://scb.taleo.net/careersection/tech/jobsearch.ftl?lang=en&radiusType=K&jobfield=5805120195&searchExpanded=false&radius=1" rel="noreferrer" target="_blank"><Button>Explore our tech openings <img src={Arrow} alt="" /></Button></a>
      </RecruitWrapper>
    </Layout>
  );
}
export default Recruit;

const RecruitWrapper = styled.section`
    text-align: center;
`; 
const Hero = styled.h3`
    height: 400px;
    background: url(${HeroImage}) 0 0 no-repeat;
    margin-bottom: 50px;
    @media (max-width: 790px) {
      height: 200px;
      background-size: cover;
    }
`;

const Top = styled.section`
    margin-bottom: 30px;
`;

const H3 = styled.h3`
    font-size: 25px;
    margin-bottom: 20px;
`;

const Statement = styled.p`
    font-size: 20px;
`;

const Button = styled.button`
    background: #0070EB;
    color: #fff;
    border: none;
    padding: 0 46px;
    line-height: 52px;
    cursor: pointer;
    transition: background-color 0.2s linear;
    font-size: 15px;
    border-radius: 25px;
    margin-top: 30px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    img {
      position: relative;
      top: 2px;
      right: -8px;
    }
    &:hover {
        background: #0070EB;
    }
    margin-bottom: 40px;
`;